import ServerRequestUtil from '../utils/ServerRequestUtil';

export default new class {

    async connect(data) {
        return ServerRequestUtil.post('/api/app/auth/quest/connect', data);
    }

    async verifyToken(data) {
        return ServerRequestUtil.post('/api/app/auth/quest/verify-token', data);
    }

    async integrate(data) {
        return ServerRequestUtil.post('/api/app/auth/quest/integrate', data);
    }

    async registration(data) {
        return ServerRequestUtil.post('/api/app/auth/quest/registration-quest', data);
    }

    async createBaseUser(data) {
        return ServerRequestUtil.post('/api/app/auth/quest/create-base-user', data);
    }

    //【AubeQuest】プロフィール入力
    async confirmRegistrationAubeQuest(registrationData) {
        return ServerRequestUtil.post('/api/app/auth/quest/confirm-registration-quest', {...registrationData });
    }

    async getConnectorByQuestId(questId) {
        return ServerRequestUtil.get(`api/app/auth/quest/${questId}/connector`, null, true);
    }

    async getQuestConnectStatus(questId) {
        return ServerRequestUtil.get(`api/app/auth/quest/${questId}/connected`, null, true);
    }

    async getTemporaryRegistrationCheck(questId) {
        return ServerRequestUtil.get(`api/app/auth/quest/${questId}/temporaryRegistrationCheck`, null, true);
    }
}
